import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,
        LoadGraphic,Step,DynamicListArea,BulkEdit,
        Dropzone,SegmentComplete} from '../components/Common';
import {Select,Button,Date,Box,Time,PageSelector,Area,
        TextButton,MiniMinusButton, EditableArea, ContactNumber,
        Checkbox,Info} from '../components/Input';
import u from '../utilities/Utilities';
import {Link} from 'react-router-dom';
import {Spreadsheet,Attachment} from '../data/Mimetypes';
import moment from 'moment';
import store from 'store';
import "../styles/misconduct-list.scss";
import "../styles/incident-list.scss";

export default class IncidentList extends React.Component{

    settings={
        /**** Page Setup ****/
        title:"Incident",
        permission:"incident",  //Accepts combined permission module as well
        //combinedField:"",     //Used when permission exists in a combined field
        url:"/incident-list",

        /**** Action Setup ****/
        addType:1,
        addURL:"/api/add-incident-entry",
        //templateURL:"/api/get-add-tenant-template",
        //bulkURL:"/api/add-bulk-tenants",
        deleteURL:"/api/delete-incident-entries",
        spreadsheetURL:"/api/generate-incident-spreadsheet",
        overviewURL:"/api/get-all-incident-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"incident-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddIncidentEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
        options:{},
        staffOptions:[],
    };

    getOptions=()=>{
        u.post({
            url:"/api/get-options",
            data:{
                keys:["incidentInvolvementType","incidentResidencyType","incidentResponsibility"],
            },
            success:(options)=>{
                this.setState({options:options});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
        
        u.post({
            url:"/api/get-staff-options",
            data:{
                permission:{incident:{update:2}}
            },
            success:(staffOptions)=>{
                this.setState({staffOptions:staffOptions});
            },
            error:(error)=>{
                this.setState({error:error})
            }
        })
    }

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (bulkEditOptions.length > 0);
        this.setState({
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:permissions.create},
                {label:"Delete Entries",ref:"delete",enabled:permissions.delete},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled},
            ],
            permissions:permissions,
        });
        this.getOptions();
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    render=()=>{
        return (
            <AppLayout ref="layout" settings={this.settings}>
                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />


                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <IncidentItem key={index}
                                              index={index}
                                              content={content}
                                              onChange={onChange}
                                              onContentChange={onContentChange}
                                              registerReference={registerRef}
                                              options={this.state.options}
                                              settings={this.settings}
                                              permissions={this.state.permissions}
                                              staffOptions={this.state.staffOptions}
                                              />
                            )
                        }
                    }
                </OverviewList>

            </AppLayout>
        )
    }
}

export class MiniIncidentList extends React.Component{

    settings={
        /**** Page Setup ****/
        title:"Incident",
        permission:"incident",  //Accepts combined permission module as well
        //combinedField:"",     //Used when permission exists in a combined field
        url:"/incident-list",
        spreadsheetURL:"/api/generate-incident-spreadsheet",
        overviewURL:"/api/get-all-incident-entries",

        /**** List Setup ****/
        listLabel:"incident-list",
        orderByField:"createdOn",
        orderByType:"descending",
        //detailsLink:"/absence-reason-list/", //Leave null if linking to list
    };

    refresh=()=>{
        this.refs['list'].refresh();
    }

    render=()=>{
        return(
            <MiniList ref="list"
                      settings={this.settings}
                      tags={this.props.tags}
                      pageLength={this.props.pageLength}
                      orderByField={this.props.orderByField}
                      orderByType={this.props.orderByType}
            />
        )
    }
}

class IncidentItem extends React.Component{

    r={};

    state={
        step:"view",
        error:"",
        loading:false,
        loadText:"",
        removeIndex:0,
        photoIndex:0,
        paging:{
            involved:1,
            attachments:1,
            assignedTo:1,
        }
    };

    static getDerivedStateFromProps(props,state){
        const involved=props.content.involved;
        const attachments=props.content.attachments;
        const assignedTo=props.content.assignedTo;

        let paging = state.paging;
        paging.maxInvolved = Math.max(Math.ceil(involved.length/10.0),1);
        paging.maxAttachments=Math.max(Math.ceil(attachments.length/10.0),1);
        paging.maxAssignedTo=Math.max(Math.ceil(assignedTo.length/10.0),1);

        
        if(paging.involved > paging.maxInvolved){
            paging.involved = paging.maxInvolved;
        }

        if(paging.attachments > paging.maxAttachments){
            paging.attachments = paging.maxAttachments;
        }

        if(paging.assignedTo > paging.maxAssignedTo){
            paging.assignedTo = paging.maxAssignedTo;
        }

        paging.involvedStart = (paging.involved-1) * 10;
        paging.involvedEnd = paging.involvedStart + 10;

        paging.attachmentsStart = (paging.attachments-1) * 10;
        paging.attachmentsEnd = paging.attachmentsStart + 10;

        paging.assignedToStart = (paging.assignedTo-1) * 10;
        paging.assignedToEnd = paging.assignedToStart + 10;

        console.log(paging);

        return state;
    }

    onAddAttachment=(files)=>{
        const {content}=this.props;
        files = files.map(
            (item)=>{
                 if(item.ext == "jpg" || item.ext == "jpeg" || item.ext == "png"){
                    item.type = "Photo"
                 }
                 else{
                    item.type = "File"
                 }
                 return item;
            }
        )
  
        u.post({
            url:"/api/incident-add-attachment",
            data:{
                incidentID:content.incidentID,
                files:files
            },
            success:(attachment)=>{
                content.attachments = attachment.concat(content.attachments);
                this.props.onChange(content.attachments,"attachments",this.props.index);
                this.setState({loading:false,step:"view",error:""});
            },
            error:(error)=>{
                this.setState({loading:false,error:error});
            }
        })
    }

    onDeleteAttachmentRequest=(index)=>{
        const {content}=this.props;

        this.setState({
            removeAttachment:index,
            step:"confirm",
            confirmClass:"text-negative",
            confirmText:"Confirm Delete Attachment " + content.attachments[index].filename,
            confirmTextDescription:"Note. This action cannot be undone",
            error:""
        });

        this.onRequestConfirm=()=>{
            this.setState({loading:true,loadText:"Deleting Attachment..."});
            const {content}=this.props;
            u.post({
                url:"/api/incident-remove-attachment",
                data:{
                    incidentID:content.incidentID,
                    attachment:content.attachments[this.state.removeAttachment]
                },
                success:()=>{
                    content.attachments.splice(this.state.removeAttachment,1);
                    this.props.onChange("attachments",content.attachments,this.props.index);
                    this.setState({step:"view",error:"",loading:false});
                },
                error:(error)=>{
                    this.setState({loading:false,error:error});
                }
            })
        };
    }

    toggleView=(isShown)=>{
        this.setState({
            showAssigned:!isShown,
            showAttachments:!isShown,
            showInvolved:!isShown
        })
    }

    onConfirmInvolved=async ()=>{
        this.setState({error:""});
        let keys=["involvementType","residencyType","nric","code","name","contactNo","address"];
        let data={};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                let current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }

        const {content}=this.props;
        const codeUsed = content.involved.filter((item)=>{return item.code == data.code});
        if(codeUsed.length > 0){
            this.r['code'].setError();
            this.setState({error:"Code has already been used"});
            return 0;
        }
        
        this.setState({loading:true,loadText:"Adding Involved..."});
        try{
            const response = await u.postAsync({
                url:"/api/add-involved-entry",
                data:{
                    ...data,
                    incidentID:content.incidentID
                }
            });
            content.involved.unshift(response.data);
            console.log(content.involved);
            this.props.onChange(content.involved,"involved",this.props.index);
            this.setState({step:"view",error:"",loading:false});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onRemoveInvolved=(index)=>{
        const {content}=this.props;
        const entry = content.involved[index];

        this.setState({
            removeInvolved:index,
            step:"confirm",
            confirmClass:"text-negative",
            confirmText:"Confirm Delete " + entry.involvementType + " - " + entry.name + "?",
            confirmTextDescription:"Note. This action cannot be undone",
            error:""
        });

        this.onRequestConfirm=()=>{
            const {content}=this.props;
            const entry = content.involved[this.state.removeInvolved];
            this.setState({loading:true,loadText:"Deleting "+entry.involvementType+" - " + entry.name + "..."});
            u.post({
                url:"/api/remove-involved-entry",
                data:{
                    incidentID:content.incidentID,
                    involved:entry
                },
                success:()=>{
                    content.involved.splice(this.state.removeInvolved,1);
                    this.props.onChange("involved",content.involved,this.props.index);
                    this.setState({step:"view",error:"",loading:false});
                },
                error:(error)=>{
                    this.setState({loading:false,error:error});
                }
            })
        };
    }

    onConfirmAssign=async ()=>{
        this.setState({error:""});
        let keys=["staffID","role","deadlineDate","deadlineTime"];
        let data={};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                let current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }

        data.deadline = data.deadlineDate + " " + data.deadlineTime;
    
        const {content}=this.props;
        this.setState({loading:true,loadText:"Adding Assignment..."});
        try{
            const response = await u.postAsync({
                url:"/api/incident-add-assign-to",
                data:{
                    ...data,
                    incidentID:content.incidentID
                }
            });
            content.assignedTo.unshift(response.data);
            this.props.onChange(content.assignedTo,"assignedTo",this.props.index);
            this.setState({step:"view",error:"",loading:false});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onDeleteAssignRequest=(index)=>{
        const {content}=this.props;
        const entry = content.assignedTo[index];

        this.setState({
            removeAssign:index,
            step:"confirm",
            confirmClass:"text-negative",
            confirmText:"Confirm Remove " + entry.staffName + "?",
            confirmTextDescription:"Staff without an assigned role will no longer receive email updates",
            error:""
        });

        this.onRequestConfirm=()=>{
            const {content}=this.props;
            const entry = content.assignedTo[this.state.removeAssign];
            this.setState({loading:true,loadText:"Removing "+entry.staffName+"..."});
            u.post({
                url:"/api/incident-remove-assign-to",
                data:{
                    incidentID:content.incidentID,
                    assignTo:entry
                },
                success:()=>{
                    content.assignedTo.splice(this.state.removeAssign,1);
                    this.props.onChange("assignedTo",content.assignedTo,this.props.index);
                    this.setState({step:"view",error:"",loading:false});
                },
                error:(error)=>{
                    this.setState({loading:false,error:error});
                }
            })
        };
    }

    onChangePage=(value,field)=>{
        let paging=this.state.paging;
        paging[field]=value;
        this.setState({paging:paging});
    }

    onViewStatement=(index)=>{
        const id = u.getKey();
        let content=Object.assign({},this.props.content);
        content.target=content.involved[index];
        store.set(id,content);
        window.open("/incident-statement/"+id,"__blank");
    }

    onClosureReport=()=>{
        const key = u.getKey();
        const {content}=this.props;
        store.set(key,content);
        window.open("/incident-closure/"+key,"__blank");
    }

    render=()=>{
        const {content,permissions,options,staffOptions}=this.props;
        const {showAttachments,showAssigned,showInvolved,residencyType,paging}=this.state;
        const canEditLow = (permissions.create == 2 || permissions.update == 2);
        const canEditHigh = (permissions.update == 2);

        return (
            <div>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>

                <div className="list-segment-error">{this.state.error}</div>

                <Step active={this.state.step=="view"}>
                    <DynamicListArea content={this.props.content}
                                     onChange={this.props.onChange}
                                     index={this.props.index}
                                     listLabel={this.props.settings.listLabel}
                                     permission={this.props.settings.permission}
                                     combinedField={this.props.settings.combinedField}
                                     bypassPermission={canEditLow}
                                     />

                    <div style={{textAlign:"center",position:"relative"}}>
                        <div>
                            <h3>Case Summary</h3>
                            <div className='case-summary'>
                                <EditableArea label="Case Summary"
                                            labelStyle={{textAlign:"left"}}
                                            field="description"
                                            values={{
                                                value:content.description,
                                                enabled:canEditLow
                                            }}
                                            rules={{rows:10}}
                                            onChange={this.props.onChange}
                                            url="/api/update-incident-info"
                                            id={content.incidentID}
                                            style={{textAlign:"left"}}
                                            />
                            </div>
                        </div>

                        {
                            (showInvolved)
                                ?
                                <div>
                                    <h3 style={{marginTop:"30px"}}>Involved Parties</h3>
                                    {
                                        (content.involved.length > 0)
                                            ?
                                            <div>
                                                <div className='list-table incident-table'>
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th className='left remove'/>
                                                                <th style={{width:"100px"}}>Involvement</th>
                                                                <th style={{width:"60px"}}>Code</th>
                                                                <th style={{width:"100px"}}>NRIC/FIN</th>
                                                                <th>Name</th>
                                                                <th>Address</th>
                                                                <th style={{width:"100px"}}>Contact No</th>
                                                                <th className='right' style={{width:"90px",textAlign:"center"}}>Statement</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                content.involved.map(
                                                                    (item,index)=>{
                                                                        if(index < paging.involvedStart || index > paging.involvedEnd){
                                                                            return null;
                                                                        }
                                                                        return(
                                                                            <tr key={index} className='item'>
                                                                                <td className='remove'>
                                                                                    <MiniMinusButton onClick={()=>{this.onRemoveInvolved(index)}}
                                                                                                     enabled={(typeof item.statement == "undefined" && canEditLow)}
                                                                                                     />
                                                                                </td> 
                                                                                <td title={item.involvementType}>{item.involvementType}</td>
                                                                                <td title={item.code}>{(item.code) ? item.code : "-"}</td>
                                                                                <td title={item.nric}>{(item.nric) ? item.nric : "-"}</td>
                                                                                <td tite={item.name}>
                                                                                    {
                                                                                        (item.residencyType == "Resident" || item.residencyType == "Staff")
                                                                                            ?
                                                                                            <Link to={"/"+item.residencyType.toLowerCase()+"/"+item.residencyID}>{item.name}</Link>
                                                                                            :
                                                                                            "(NR) " + item.name
                                                                                    }
                                                                                </td>
                                                                                <td title={item.address}>{(item.address) ? item.address : "-"}</td>
                                                                                <td title={item.contactNo}>{(item.contactNo) ? item.contactNo : "-"}</td>
                                                                                <td style={{width:"90px",textAlign:"center"}}>
                                                                                    {
                                                                                        (item.statement)
                                                                                            ?
                                                                                            <TextButton onClick={()=>{this.onViewStatement(index)}} style={{margin:"0"}}>View</TextButton>
                                                                                            :
                                                                                            <TextButton enabled={canEditLow} onClick={()=>{this.onViewStatement(index)}} style={{margin:"0"}}>Add</TextButton>
                                                                                    }
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    }
                                                                )
                                                            }
                                                        </tbody>
                                                    </table>
                                                    {
                                                        (paging?.maxInvolved > 1)
                                                            ?
                                                            <div style={{margin:"20px auto 10px auto"}}>
                                                                <PageSelector page={paging?.involved}
                                                                            maxPage={paging?.maxInvolved}
                                                                            onChange={(value)=>{this.onChangePage(value,"involved")}}/>                                                    
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                                
                                            </div>
                                            :
                                            <div className='list-placeholder' style={{width:"1280px"}}>
                                                <h3>No Involved Parties Added</h3>
                                                <div>Click add below to add involved party</div>
                                            </div>
                                    }
                                    <div style={{margin:"20px auto",textAlign:"center"}}>
                                        <TextButton onClick={()=>{this.setState({showInvolved:false})}}>Minimize Section</TextButton>
                                        {
                                            (canEditLow)
                                                ?
                                                <TextButton onClick={()=>{this.setState({step:"add-involved",error:""})}}>Add Involved</TextButton>
                                                :
                                                null
                                        }
                                    </div>
                                </div>
                                :
                                null
                        }
                        
                        <div style={{position:"relative",width:"1280px",display:"flex",alignItems:"flex-start",justifyContent:"space-between",maxWidth:"100%",margin:"auto"}}>
                            {
                                (showAttachments)
                                    ?
                                    <div className={(showAssigned) ? 'small-table' : 'long-table'}>
                                        <h3 style={{marginTop:"20px"}}>Photos & Attachments</h3>
                                        {
                                            (content.attachments.length > 0)
                                                ?
                                                <div className="list-table-container">
                                                    <div className={"list-table" + ((showAssigned) ? "" : " incident-table")} style={{maxHeight:"none"}}>
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th className="remove left"/>
                                                                    <th>Attachment</th>
                                                                    <th className="attachment-short"/>
                                                                    <th className="attachment-short"/>
                                                                    <th className="attachment-download right"/>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    content.attachments.map(
                                                                        (item,index)=>{
                                                                            return(
                                                                                <tr key={index} className={((item.type=="photo") ? "photo-tr" : "") + " item"}>
                                                                                    <td className="remove">
                                                                                        <div style={{position:"relative",width:"15px",height:"15px"}}>
                                                                                            <MiniMinusButton onClick={()=>{this.onDeleteAttachmentRequest(index)}}
                                                                                                            enabled={canEditLow}
                                                                                                            />
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className='nowrap'>{item.filename}</td>
                                                                                    <td className="attachment-short">{item.staffName}</td>
                                                                                    <td className="attachment-short">{(item.uploadOn=="-") ? "-" : moment(item.uploadOn).format("DD MMM YY hh:mma")}</td>
                                                                                    <td className={"attachment-download" + ((item.type == "Photo") ? " photo" : "")}>
                                                                                        {
                                                                                            (item.type == "Photo")
                                                                                                ?
                                                                                                <img src={item.filestamp} 
                                                                                                    className="attachment-image"
                                                                                                    resizemode="contain"
                                                                                                    onClick={()=>{window.open(item.filestamp,"__blank")}}
                                                                                                    />
                                                                                                :
                                                                                                <img className="misconduct-download"
                                                                                                    src="/images/input/down-arrow.png"
                                                                                                    onClick={()=>{u.download(item.filename,item.filestamp)}}
                                                                                                    />
                                                                                        }
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    )
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                :
                                                <div className="list-placeholder" style={{width:"100%"}}>
                                                    <h3>No Photos & Attachments</h3>
                                                    <div>Click below to add new photo or attachment</div>
                                                </div>
                                        }
                                        <div style={{margin:"20px auto",textAlign:"center"}}>
                                            <TextButton onClick={()=>{this.setState({showAttachments:false})}}>Minimize Section</TextButton>
                                            {
                                                (canEditLow)
                                                    ?
                                                    <TextButton enabled={canEditLow} onClick={()=>{this.setState({step:"add-attachment",error:""})}}>Add Attachment</TextButton>
                                                    :
                                                    null
                                            }
                                        </div>
                                    </div>
                                    :
                                    null
                            }

                            {
                                (showAssigned)
                                    ?
                                    <div className={(showAttachments) ? 'small-table' : "long-table"}>
                                        <h3 style={{marginTop:"20px"}}>Assigned To</h3>
                                        {
                                            (content.assignedTo.length > 0)
                                                ?
                                                <div className="list-table-container">
                                                    <div className={"list-table" + ((showAttachments) ? "" : " incident-table")} style={{maxHeight:"none"}}>
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th className="remove left"/>
                                                                    <th>Staff</th>
                                                                    <th className="attachment-short align-left">Role</th>
                                                                    <th className="attachment-short right">Deadline</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    content.assignedTo.map(
                                                                        (item,index)=>{
                                                                            return(
                                                                                <tr key={index} className={((item.type=="photo") ? "photo-tr" : "") + " item"}>
                                                                                    <td className="remove">
                                                                                        <div style={{position:"relative",width:"15px",height:"15px"}}>
                                                                                            <MiniMinusButton onClick={()=>{this.onDeleteAssignRequest(index)}}
                                                                                                            enabled={canEditHigh}
                                                                                                            />
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className='nowrap'><Link to={"/staff/"+item.staffID}>{item.staffName}</Link></td>
                                                                                    <td className="attachment-short align-left">{item.role}</td>
                                                                                    <td className="attachment-short">{moment(item.deadline).format("DD MMM YY hh:mma")}</td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    )
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                :
                                                <div className="list-placeholder" style={{width:"100%"}}>
                                                    <h3>No Role Assignments</h3>
                                                    <div>Click below to assign staff</div>
                                                </div>
                                        }
                                        <div style={{margin:"20px auto",textAlign:"center"}}>
                                            <TextButton onClick={()=>{this.setState({showAssigned:false})}}>Minimize Section</TextButton>
                                            {
                                                (canEditHigh)
                                                    ?
                                                    <TextButton onClick={()=>{this.setState({step:"add-assign",error:""})}}>Assign Staff</TextButton>
                                                    :
                                                    null
                                            }
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                    </div>

                    <div style={{margin:"30px auto 20px auto",textAlign:"center"}}>
                        <Button enabled={canEditHigh} onClick={this.onClosureReport}>Investigation Closure</Button>
                    </div>

                    <div style={{margin:"20px auto 10px auto",textAlign:'center'}}>
                        {
                            (showInvolved) ? null : <TextButton onClick={()=>{this.setState({showInvolved:true})}}>See Involved ({content.involved.length})</TextButton>
                        }
                        {
                            (showAssigned) ? null : <TextButton onClick={()=>{this.setState({showAssigned:true})}}>See Assigned ({content.assignedTo.length})</TextButton>
                        }
                        {
                            (showAttachments) ? null : <TextButton onClick={()=>{this.setState({showAttachments:true})}}>See Attachments ({content.attachments.length})</TextButton>
                        }
                        <TextButton onClick={()=>{this.toggleView((showInvolved || showAssigned || showAttachments))}}>
                            {
                                (showInvolved || showAssigned || showAttachments)
                                    ?
                                    "Minimize All Sections"
                                    :
                                    "See All"
                            }
                        </TextButton>
                    </div>
                </Step>

                <Step active={this.state.step=="add-attachment"} scroll={true}>
                    <div style={{fontSize:"14px",textAlign:"center"}}>
                        <Dropzone label={"Attachment"}
                                  accessibleForPreview={true}
                                  onAdded={()=>{this.setState({loading:true,loadText:"Uploading..."})}}
                                  onUploaded={this.onAddAttachment}
                                  onError={(error)=>{this.setState({error:error,loading:false})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..." + value + "%"})}}
                                  filetypes={Attachment}
                                  multiple={true}
                                  />

                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="add-involved"} scroll={true}>
                    <div style={{position:"relative",textAlign:"center",fontSize:"14px"}}>
                        <h3>Complete the following to continue</h3>
                        <div>
                            <div className='segment-full-item'>
                                <div className='segment-item-label'>Involvement:</div>
                                <div className='segment-item-input'>
                                    <Select ref={(ref)=>{this.r["involvementType"]=ref}}
                                            label="Involvement"
                                            values={{options:options.incidentInvolvementType}}
                                            rules={{required:true}}
                                            />
                                </div>
                            </div>
                            <div className='segment-full-item'>
                                <div className='segment-item-label'>Residency Type:</div>
                                <div className='segment-item-input'>
                                    <Select ref={(ref)=>{this.r["residencyType"]=ref}}
                                            label="Residency Type"
                                            values={{options:options.incidentResidencyType}}
                                            rules={{required:true}}
                                            onChange={(value)=>{this.setState({residencyType:value})}}
                                            />
                                </div>
                            </div>

                            <div className='segment-full-item'>
                                <div className='segment-item-label'>NRIC/FIN:</div>
                                <div className='segment-item-input'>
                                    <Box ref={(ref)=>{this.r["nric"]=ref}}
                                         label="NRIC/FIN"
                                         rules={{required:(residencyType != "Non-Resident")}}
                                         />
                                </div>
                            </div>

                            <div className='segment-full-item'>
                                <div className='segment-item-label'>Code (Max 4 Letter):</div>
                                <div className='segment-item-input'>
                                    <Box ref={(ref)=>{this.r["code"]=ref}}
                                         label="Code"
                                         rules={{required:true,maxLength:4,toUpperCase:true}}
                                         />
                                </div>
                            </div>
                            
                            {
                                (residencyType == "Non-Resident")
                                    ?
                                    <div className='segment-full-item'>
                                        <div className='segment-item-label'>Full Name:</div>
                                        <div className='segment-item-input'>
                                            <Box ref={(ref)=>{this.r["name"]=ref}}
                                                label="Name"
                                                rules={{required:true}}
                                                />
                                        </div>
                                    </div>
                                    :
                                    null
                            }

                            {
                                (residencyType == "Non-Resident")
                                    ?
                                    <div className='segment-full-item'>
                                        <div className='segment-item-label'>Contact No:</div>
                                        <div className='segment-item-input'>
                                            <ContactNumber ref={(ref)=>{this.r["contactNo"]=ref}}
                                                           label="Contact No"
                                                           rules={{placeholder:"Optional"}}
                                                           contactNumberField="contactNumber"
                                                           countryCodeField="countryCode"
                                                           />
                                        </div>
                                    </div>
                                    :
                                    null
                            }

                            {
                                (residencyType == "Non-Resident")
                                    ?
                                    <div className='segment-full-item'>
                                        <div className='segment-item-label'>Address:</div>
                                        <div className='segment-item-input'>
                                            <Box ref={(ref)=>{this.r["address"]=ref}}
                                                    label="Address"
                                                    rules={{placeholder:"Optional"}}
                                                    />
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onConfirmInvolved}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="add-assign"} scroll={true}>
                    <div style={{position:"relative",textAlign:"center",fontSize:"14px"}}>
                        <h3>Complete the following to continue</h3>
                        <div>
                            <div className='segment-full-item'>
                                <div className='segment-item-label'>Staff:</div>
                                <div className='segment-item-input'>
                                    <Select ref={(ref)=>{this.r["staffID"]=ref}}
                                            label="Staff"
                                            values={{options:staffOptions}}
                                            rules={{required:true}}
                                            />
                                </div>
                            </div>
                            <div className='segment-full-item'>
                                <div className='segment-item-label'>Role:</div>
                                <div className='segment-item-input'>
                                    <Select ref={(ref)=>{this.r["role"]=ref}}
                                            label="Role"
                                            values={{options:options.incidentResponsibility}}
                                            rules={{required:true}}
                                            />
                                </div>
                            </div>
                            <div className='segment-full-item'>
                                <div className='segment-item-label'>Deadline Date:</div>
                                <div className='segment-item-input'>
                                    <Date ref={(ref)=>{this.r["deadlineDate"]=ref}}
                                          label="Deadline Date"
                                          rules={{required:true}}
                                          range={[0,1]}
                                          />
                                </div>
                            </div>
                            <div className='segment-full-item'>
                                <div className='segment-item-label'>Deadline Time:</div>
                                <div className='segment-item-input'>
                                    <Time ref={(ref)=>{this.r["deadlineTime"]=ref}}
                                          label="Deadline Time"
                                          rules={{required:true,skipSeconds:true}}
                                          />
                                </div>
                            </div>
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onConfirmAssign}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="confirm"} scroll={true}>
                    <div style={{padding:"30px 0",textAlign:"center"}}>
                        <h2 className={this.state.confirmClass}>{this.state.confirmText}</h2>
                        <div className="list-segment-note">{this.state.confirmTextDescription}</div>
                        <div className="list-segment-buttons">
                            <Button onClick={()=>{this.setState({step:"view"})}}>Back</Button>
                            <Button onClick={()=>{this.onRequestConfirm()}}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="complete"} scroll={true}>
                    <div style={{padding:"30px 0",textAlign:"center"}}>
                        <SegmentComplete onComplete={()=>{this.setState({step:"view",error:""})}}>
                            <h2>{this.state.completeText}</h2>
                        </SegmentComplete>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddIncidentEntry extends React.Component{
    r={};

    state={
        additional:{},
        dormOptions:[],
        offenseTypeOptions:[],
        entryData:{
            offenses:[],
            photos:[],
            attachments:[],
        },
        options:{},
        tenantInfo:{},
        step:"resident",
        loading:false,
        loadText:"",
        dimensions:{
          width:500,
          height:200,
        },
        autoCaseNumber:true,
    };

    show=(show)=>{
        this.refs[this.props.reference].show(show);
    }

    componentDidMount=()=>{
        this.getDormOptions();
        this.getOptions();
    }

    getDormOptions=()=>{
        u.post({
            url:"/api/get-estate-options",
            data:{
              type:"dorm"
            },
            success:(dormOptions)=>{
                this.setState({dormOptions:dormOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    getOptions=()=>{
        u.post({
            url:"/api/get-options",
            data:{
                keys:["incidentNature","incidentCluster","incidentInvolvementType","incidentResidencyType"]
            },
            success:(options)=>{
                this.setState({options:options});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        })
    }

    onCancel=()=>{
        this.setState({
          step:"resident",
          error:"",
          entryData:{
            offenses:[],
            photos:[],
            attachments:[],
          }
      });
        this.props.onToggleForm(this.props.reference,false);
    }

    onValidate=()=>{
        this.setState({error:""});
        const keys=["dormID","involvementType","residencyType","nric","code","name","contactNo","address","caseNumber","natureOfIncident","cluster","location",
                    "reportDate","reportTime","incidentDate","incidentTime","agencyInvolvement",
                    "description"
                   ];
        let data={};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current = this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]] = current.value;
            }
        }

        data.reportDateTime = data.reportDate + " " + data.reportTime;
        data.incidentDateTime = data.incidentDate + " " + data.incidentTime;

        this.refs[this.props.reference].onValidated(data);
    }

    onChange=(value,field,index,option)=>{
        let entryData = this.state.entryData;
        entryData[field] = value;
        this.setState({entryData:entryData});
    }

    onComplete=()=>{
        this.setState({
          step:"resident",
          error:"",
          loading:false,
          entryData:{
            offenses:[],
            photos:[],
            attachments:[],
          }
        });
    }

    onChangeAuto=(value)=>{
        this.setState({autoCaseNumber:value});
        if(value){
            this.r['caseNumber'].clear();
        }
    }

    render=()=>{
        const {options,autoCaseNumber,residencyType} = this.state;
        const natureOfIncidentOptions = (options.incidentNature) ? options.incidentNature.map((item)=>{return item.value}) : [];

        return(
            <AddListItem ref={this.props.reference}
                         settings={this.props.settings}
                         reference={this.props.reference}
                         filetypes={Spreadsheet}
                         additional={this.state.additional}
                         onToggleForm={this.props.onToggleForm}
                         onComplete={this.onComplete}
                         stepScroll={true}
                         >

                <div className="segment-content" style={{position:"relative",textAlign:"center"}}>
                    <div className="segment-error">{this.state.error}</div>
                    <LoadGraphic active={this.state.loading} text={this.state.loadText}/>

                    <div>
                        <h3>Complete the following to continue</h3>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Dormitory</div>
                            <div className="segment-item-input">
                                <Select ref={(ref)=>{this.r["dormID"]=ref}}
                                        values={{options:this.state.dormOptions}}
                                        label="Dormitory"
                                        />
                            </div>
                        </div>
                        <div className='segment-full-item'>
                            <div className='segment-item-label'>Reporter Involvement:</div>
                            <div className='segment-item-input'>
                                <Select ref={(ref)=>{this.r["involvementType"]=ref}}
                                        label="Involvement"
                                        values={{options:options.incidentInvolvementType}}
                                        rules={{required:true}}
                                        />
                            </div>
                        </div>

                        <div className='segment-full-item'>
                            <div className='segment-item-label'>Reporter Residency:</div>
                            <div className='segment-item-input'>
                                <Select ref={(ref)=>{this.r["residencyType"]=ref}}
                                        label="Residency Type"
                                        values={{options:options.incidentResidencyType}}
                                        rules={{required:true}}
                                        onChange={(value)=>{this.setState({residencyType:value})}}
                                        />
                            </div>
                        </div>

                        <div className='segment-full-item'>
                            <div className='segment-item-label'>Reporter NRIC/FIN:</div>
                            <div className='segment-item-input'>
                                <Box ref={(ref)=>{this.r["nric"]=ref}}
                                        label="NRIC/FIN"
                                        rules={{required:(residencyType != "Non-Resident"),placeholder:(residencyType == "Non-Resident") ? "Optional" : ""}}
                                        />
                            </div>
                        </div>

                        <div className='segment-full-item'>
                            <div className='segment-item-label'>Reporter Code: <Info title="Short code to represent this involved party, such as A1, V1 or I3"/></div>
                            <div className='segment-item-input'>
                                <Box ref={(ref)=>{this.r["code"]=ref}}
                                     label="Code"
                                     rules={{required:true,maxLength:4,toUpperCase:true}}
                                     />
                            </div>
                        </div>
                        
                        {
                            (residencyType == "Non-Resident")
                                ?
                                <div className='segment-full-item'>
                                    <div className='segment-item-label'>Reporter Name:</div>
                                    <div className='segment-item-input'>
                                        <Box ref={(ref)=>{this.r["name"]=ref}}
                                            label="Name"
                                            rules={{required:true}}
                                            />
                                    </div>
                                </div>
                                :
                                null
                        }

                        {
                            (residencyType == "Non-Resident")
                                ?
                                <div className='segment-full-item'>
                                    <div className='segment-item-label'>Reporter Contact No:</div>
                                    <div className='segment-item-input'>
                                        <ContactNumber ref={(ref)=>{this.r["contactNo"]=ref}}
                                                        label="Contact No"
                                                        rules={{placeholder:"Optional"}}
                                                        contactNumberField="contactNumber"
                                                        countryCodeField="countryCode"
                                                        />
                                    </div>
                                </div>
                                :
                                null
                        }

                        {
                            (residencyType == "Non-Resident")
                                ?
                                <div className='segment-full-item'>
                                    <div className='segment-item-label'>Reporter Address:</div>
                                    <div className='segment-item-input'>
                                        <Box ref={(ref)=>{this.r["address"]=ref}}
                                                label="Address"
                                                rules={{placeholder:"Optional"}}
                                                />
                                    </div>
                                </div>
                                :
                                null
                        }

                        <div className="segment-full-item">
                            <div className="segment-item-label">Case Number:</div>
                            <div className="segment-item-input">
                                <div className="segment-input-checkboxable">
                                    <Box ref={(ref)=>{this.r['caseNumber']=ref}}
                                         label="Case Number"
                                         values={{enabled:!autoCaseNumber}}
                                         rules={{required:!autoCaseNumber}}
                                         />
                                </div>
                                <div className="segment-input-checkbox">
                                    <div className="segment-input-checkbox-text">AUTO</div>
                                    <Checkbox style={{margin:0}}
                                              values={{value:autoCaseNumber}}
                                              label="Auto Case Number"
                                              onChange={this.onChangeAuto}
                                              />
                                </div>
                            </div>
                        </div>
                        <div className="segment-full-item" style={{zIndex:10}}>
                            <div className="segment-item-label">Nature of Incident:</div>
                            <div className="segment-item-input">
                                <Box ref={(ref)=>{this.r['natureOfIncident']=ref}}
                                     label="Nature of Incident"
                                     rules={{
                                        required:true,
                                        list:natureOfIncidentOptions,
                                        listHeight:"150px"
                                     }}
                                     />
                            </div>
                        </div>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Cluster:</div>
                            <div className="segment-item-input">
                                <Select ref={(ref)=>{this.r['cluster']=ref}}
                                        label="Cluster"
                                        values={{options:options.incidentCluster}}
                                        rules={{required:true}}
                                        />
                            </div>
                        </div>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Incident Location:</div>
                            <div className="segment-item-input">
                                <Box ref={(ref)=>{this.r['location']=ref}}
                                     label="Location"
                                     rules={{required:true}}
                                     />
                            </div>
                        </div>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Reported Date:</div>
                            <div className="segment-item-input">
                                <Date ref={(ref)=>{this.r['reportDate']=ref}}
                                      label="Report Date"
                                      range={[0,1]}
                                      rules={{required:true}}
                                      />
                            </div>
                        </div>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Reported Time:</div>
                            <div className="segment-item-input">
                                <Time ref={(ref)=>{this.r['reportTime']=ref}}
                                      label="Report Time"
                                      rules={{required:true,skipSeconds:true}}
                                      />
                            </div>
                        </div>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Incident Date:</div>
                            <div className="segment-item-input">
                                <Date ref={(ref)=>{this.r['incidentDate']=ref}}
                                      label="Incident Date"
                                      range={[0,1]}
                                      rules={{required:true}}
                                      />
                            </div>
                        </div>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Incident Time:</div>
                            <div className="segment-item-input">
                                <Time ref={(ref)=>{this.r['incidentTime']=ref}}
                                      label="Incident Time"
                                      rules={{required:true,skipSeconds:true}}
                                      />
                            </div>
                        </div>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Agency Involvement:</div>
                            <div className="segment-item-input">
                                <Area ref={(ref)=>{this.r['agencyInvolvement']=ref}}
                                      label="Agency Involvement"
                                      rules={{rows:5}}
                                      />
                            </div>
                        </div>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Case Summary:</div>
                            <div className="segment-item-input">
                                <Area ref={(ref)=>{this.r['description']=ref}}
                                      label="Case Summary"
                                      rules={{rows:5}}
                                      />
                            </div>
                        </div>
                        <div className="segment-buttons">
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={this.onValidate}>Create</Button>
                        </div>
                    </div>     
                </div>
            </AddListItem>
        )
    }
}
